import { Delete } from '@mui/icons-material';
import { Box, Divider, Icon, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { RequireRole } from 'app/components/require-role';
import { GeneralConstants } from 'app/constants/general-constants';
import { Role } from 'app/constants/role';
import { CrisRequest } from 'app/model';

interface RequestMenuProps {
    selectedRequest: CrisRequest;
}

export class RequestMenu extends React.Component<RequestMenuProps> {
    public render(): React.ReactNode {
        const request = this.props.selectedRequest;
        const requestId = request.id;

        return (
            <Box className='p-2' width='12rem'>
                <Typography variant='h5'>CS-{`${request.id}`.substr(0, GeneralConstants.SHORT_ID_LENGTH)}</Typography>
                <Divider className='mt-2' />
                <List>
                    <ListItem
                        button
                        activeClassName='Mui-selected'
                        component={NavLink}
                        to={`/cris/request/${requestId}`}
                        exact
                    >
                        <ListItemIcon>
                            <Icon>check_box</Icon>
                        </ListItemIcon>
                        <ListItemText primary='Details' />
                    </ListItem>
                    <RequireRole roles={Role.CRIS_USER}>
                        <ListItem
                            button
                            activeClassName='Mui-selected'
                            component={NavLink}
                            to={`/cris/request/${requestId}/actions`}
                        >
                            <ListItemIcon>
                                <Icon>fact_check</Icon>
                            </ListItemIcon>
                            <ListItemText primary='Actions' />
                        </ListItem>
                        <ListItem
                            button
                            activeClassName='Mui-selected'
                            component={NavLink}
                            to={`/cris/request/${requestId}/execute`}
                        >
                            <ListItemIcon>
                                <Icon>restart_alt</Icon>
                            </ListItemIcon>
                            <ListItemText primary='Execute' />
                        </ListItem>
                    </RequireRole>
                    <RequireRole roles={Role.CRIS_MANAGER}>
                        <ListItem
                            button
                            activeClassName='Mui-selected'
                            component={NavLink}
                            to={`/cris/request/${requestId}/delete`}
                        >
                            <ListItemIcon>
                                <Delete />
                            </ListItemIcon>
                            <ListItemText primary='Delete' />
                        </ListItem>
                    </RequireRole>
                </List>
            </Box>
        );
    }
}
